import React, { createContext, useContext } from "react";

export const AgentContext = createContext(null);

export function useAgent() {
  return useContext(AgentContext);
}

export function AgentProvider({ agent, children }) {
  return <AgentContext.Provider value={agent}>{children}</AgentContext.Provider>;
}
